export default __webpack_public_path__ + "static/media/explorer-kraver.f2ca5d89.svg";